import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTable = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.6875 9.53125H8.15625V5.875H1.6875V9.53125ZM1.6875 11.2188V14.875C1.6875 15.1914 1.93359 15.4375 2.25 15.4375H8.15625V11.2188H1.6875ZM9.84375 15.4375H15.75C16.0312 15.4375 16.3125 15.1914 16.3125 14.875V11.2188H9.84375V15.4375ZM16.3125 9.53125V5.875H9.84375V9.53125H16.3125ZM2.25 1.375H15.75C16.9805 1.375 18 2.39453 18 3.625V14.875C18 16.1406 16.9805 17.125 15.75 17.125H2.25C0.984375 17.125 0 16.1406 0 14.875V3.625C0 2.39453 0.984375 1.375 2.25 1.375Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconTable);
export { ForwardRef as ReactComponent };
